import { EMPTY_ARR, NOT_NULL } from '../../constants';
import { Doc, DocFilters } from '../../types';
import { useRootDocumentOrFail } from '../useRootDocumentOrFail';

export const useRootDocumentDocs = (filters: DocFilters): Doc[] => {
  const { docs } = useRootDocumentOrFail();

  return (docs || EMPTY_ARR).filter((doc: Doc) =>
    Object.keys(filters).every((key) => {
      const attrName = key as keyof DocFilters;
      const value = doc[attrName];
      const filterValue = filters[attrName];
      if (filterValue === NOT_NULL) return !!value;
      return value === filterValue;
    }),
  );
};
